<template>
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <router-link to="/" class="brand-link">
      <img src="/adminlte/dist/img/kurdamovillogo.png" alt="KurdaMovil" class="brand-image img-circle elevation-3" style="opacity: .8">
      <span class="brand-text font-weight-light">KurdaMovil</span>
    </router-link>

    <!-- Sidebar -->
    <div class="sidebar">
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" role="menu" data-accordion="false">

          <!-- Empresa -->
          <li class="nav-item" v-if="puedeEmpresa" :class="{ 'menu-open': isGroupOpen.empresa }">
            <a href="#" class="nav-link" :class="{ active: isGroupOpen.empresa }" @click.prevent="toggle('empresa')">
              <i class="nav-icon fas fa-store"></i>
              <p>
                Empresa
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview" v-show="isGroupOpen.empresa">
              <li class="nav-item" v-if="can('ver-empresas')">
                <router-link to="/empresa" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Datos Generales</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="can('ver-proveedores')">
                <router-link to="/proveedores" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Proveedores</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="can('ver-almacenes')">
                <router-link to="/almacenes" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Almacenes</p>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Inventario -->
          <li class="nav-item" v-if="puedeInventario" :class="{ 'menu-open': isGroupOpen.inventario }">
            <a href="#" class="nav-link" :class="{ active: isGroupOpen.inventario }" @click.prevent="toggle('inventario')">
              <i class="nav-icon fas fa-list"></i>
              <p>
                Inventario
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview" v-show="isGroupOpen.inventario">
              <li class="nav-item" v-if="can('ver-productos')">
                <router-link to="/catalogo" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Catalogo</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="can('ver-categorias')">
                <router-link to="/categorias" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Categorias</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="can('ver-inventarios')">
                <router-link to="/inventario" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Inventario General</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="can('ver-movimientos')">
                <router-link to="/movimientos" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Movimientos</p>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Cartera de clientes -->
          <li class="nav-item" v-if="can('ver-clientes')" :class="{ 'menu-open': isGroupOpen.clientes }">
            <a href="#" class="nav-link" :class="{ active: isGroupOpen.clientes }" @click.prevent="toggle('clientes')">
              <i class="nav-icon fas fa-users"></i>
              <p>
                Cartera de clientes
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview" v-show="isGroupOpen.clientes">
              <li class="nav-item">
                <router-link to="/clientes" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Clientes Frecuentes</p>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Cuentas -->
          <li class="nav-item" v-if="puedeCuentas" :class="{ 'menu-open': isGroupOpen.cuentas }">
            <a href="#" class="nav-link" :class="{ active: isGroupOpen.cuentas }" @click.prevent="toggle('cuentas')">
              <i class="nav-icon fas fa-dollar-sign"></i>
              <p>
                Cuentas
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview" v-show="isGroupOpen.cuentas">
              <li class="nav-item" v-if="can('ver-creditos')">
                <router-link to="/creditos" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Control de creditos</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="can('ver-pagos')">
                <router-link to="/verpagos" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Pagos</p>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Ventas -->
          <li class="nav-item" v-if="can('ver-ventas')" :class="{ 'menu-open': isGroupOpen.ventas }">
            <a href="#" class="nav-link" :class="{ active: isGroupOpen.ventas }" @click.prevent="toggle('ventas')">
              <i class="nav-icon fas fa-cash-register"></i>
              <p>
                Ventas
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview" v-show="isGroupOpen.ventas">
              <li class="nav-item">
                <router-link to="/nuevaventa" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Crear orden de venta</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/ventas" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Listado</p>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Logistica -->
          <li class="nav-item" v-if="can('ver-logistica')" :class="{ 'menu-open': isGroupOpen.logistica }">
            <a href="#" class="nav-link" :class="{ active: isGroupOpen.logistica }" @click.prevent="toggle('logistica')">
              <i class="nav-icon fas fa-truck-fast"></i>
              <p>
                Logistica
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview" v-show="isGroupOpen.logistica">
              <li class="nav-item">
                <router-link to="/ventalog" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Asignar Ventas</p>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Promociones -->
          <li class="nav-item" :class="{ 'menu-open': isGroupOpen.promociones }" v-if="can('ver-promociones')">
            <a href="#" class="nav-link" :class="{ active: isGroupOpen.promociones }" @click.prevent="toggle('promociones')">
              <i class="fas fa-percent nav-icon"></i>
              <p>
                Promociones
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview" v-show="isGroupOpen.promociones">
              <li class="nav-item">
                <router-link to="/promociones" class="nav-link" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Listado</p>
                </router-link>
                <router-link to="/nuevapromocion" class="nav-link" v-if="can('crear-promociones')" active-class="active" exact>
                  <i class="far fa-circle nav-icon"></i>
                  <p>Nueva Promocion</p>
                </router-link>
              </li>
            </ul>
          </li>
          <!-- Reportes -->
          <li class="nav-item" v-if="can('gestionar-reportes')">
            <router-link to="/reportes" class="nav-link" active-class="active" exact>
              <i class="nav-icon fas fa-chart-line"></i>
              <p>Reportes</p>
            </router-link>
          </li>
          <!--cierres-->
          <li class="nav-item" v-if="can('gestionar-cierres')">
            <router-link to="/cierres" class="nav-link" active-class="active" exact>
              <i class="nav-icon fas fa-file-invoice-dollar"></i>
              <p>Cierres</p>
            </router-link>
          </li>

          <!-- Respaldos -->
          <li class="nav-item" v-if="can('gestionar-respaldos')">
            <router-link to="/respaldos" class="nav-link" active-class="active" exact>
              <i class="nav-icon fas fa-database"></i>
              <p>Respaldos BD</p>
            </router-link>
          </li>

          <!-- Administración -->
          <li class="nav-item" v-if="can('gestionar-usuarios')">
            <router-link to="/admin" class="nav-link" active-class="active" exact>
              <i class="nav-icon fas fa-user-shield"></i>
              <p>Admin Panel</p>
            </router-link>
          </li>
          <!-- Soporte -->
          <li class="nav-item">
            <router-link to="/tickets" class="nav-link" active-class="active" exact>
              <i class="nav-icon fas fa-headset"></i>
              <p>Soporte</p>
            </router-link>
          </li>
        </ul>
        

        <div class="sidebar-footer">
          <!-- Footer content -->
        </div>
      </nav>
    </div>
  </aside>
</template>

<script setup>
import { reactive, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { usePermissions } from '@/composables/usePermissions';

// permisos
const { can } = usePermissions();

// ruta actual
const route = useRoute();

// estado simple para grupos abiertos
const isGroupOpen = reactive({
  empresa: false,
  inventario: false,
  clientes: false,
  cuentas: false,
  ventas: false,
  logistica: false,
  promociones: false
});

// toggle genérico
function toggle(group) {
  isGroupOpen[group] = !isGroupOpen[group];
}

// computed para ocultar grupo Empresa si no tiene permisos
const puedeEmpresa = computed(() =>
  !!(can('ver-empresas') || can('ver-proveedores') || can('ver-almacenes'))
);

const puedeInventario = computed(() =>
  !!(can('ver-productos') || can('ver-categorias') || can('ver-inventarios') || can('ver-movimientos'))
);

const puedeCuentas = computed(() =>
  !!(can('ver-creditos') || can('ver-pagos'))
);

// Abrir automáticamente grupo según ruta activa (sin lógica compleja)
watch(
  () => route.path,
  (p) => {
    isGroupOpen.empresa = p.startsWith('/empresa') || p.startsWith('/proveedores') || p.startsWith('/almacenes');
    isGroupOpen.inventario = p.startsWith('/catalogo') || p.startsWith('/categorias') || p.startsWith('/inventario') || p.startsWith('/movimientos');
    isGroupOpen.clientes = p.startsWith('/clientes');
    isGroupOpen.cuentas = p.startsWith('/creditos') || p.startsWith('/verpagos');
    isGroupOpen.ventas = p.startsWith('/nuevaventa') || p.startsWith('/ventas') || p.startsWith('/ventas-anuladas');
    isGroupOpen.logistica = p.startsWith('/ventalog');
    isGroupOpen.promociones = p.startsWith('/promociones') || p.startsWith('/nuevapromocion');
  },
  { immediate: true }
);
</script>

<style scoped>
/* estilos mínimos para resaltar y abrir (AdminLTE usa menu-open y active) */
.nav-item.menu-open > .nav-link {
  background: rgba(13, 110, 253, 0.08);
}
.nav-link.active {
  background-color: #0d6efd;
  color: #fff;
  font-weight: 600;
}
.nav-treeview { padding-left: 1rem; }
/* pequeños ajustes visuales */
.brand-link { display:flex; align-items:center; gap: .5rem; }
.sidebar-footer { padding: .5rem 1rem; color: rgba(255,255,255,.6); }
</style>